import { IMenuHeader } from '@libraries/api/login/login.types';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
const { persistAtom } = recoilPersist();

export const modalPromoHomepage = atom<boolean>({
  key: 'Common/modalPromoHomepage',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const appTheme = atom<'sidebar' | 'navbar'>({
  key: 'Common/appTheme',
  default: 'navbar',
  effects_UNSTABLE: [persistAtom],
});

export const appMenu = atom<IMenuHeader[]>({
  key: 'Common/appMenu',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const sidebarIsOpen = atom<boolean>({
  key: 'Common/sidebarIsOpen',
  default: false,
});

export const receivingIsOpen = atom<boolean>({
  key: 'Common/receivingIsOpen',
  default: false,
});

export const refreshCounter = atom<number>({
  key: 'Common/refreshCounter',
  default: 0,
  effects_UNSTABLE: [persistAtom],
});

export const isLockedState = atom<boolean>({
  key: 'Common/isLockedState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const sidebarScrollPosition = atom<number>({
  key: 'sidebarScrollPosition',
  default: 0,
});

export const isOpenExportList = atom<boolean>({
  key: 'Common/isOpenExportList',
  default: false,
});
